import React, { useContext, useState, useRef, useEffect } from 'react';
import { ReactComponent as Observatory } from '../images/observatory.svg'; 
import { ReactComponent as ContourLines } from '../images/contourlines.svg';
import { Link } from 'react-router-dom';
import News from '../components/News.js';
import Subtitle from '../components/Subtitle.js';
import Pager from '../components/Pager.js';
import Sorters from '../components/Sorters.js';
import Loading from '../components/Loading.js';
import useDocumentTitle from '../components/useDocumentTitle';
import TittleNavBar from '../components/tittleNavBar.js';
import MyNewsContext from '../context/NewsContext';
import WOW from 'wowjs';
import { OBSERVATORYLINK } from '../config';
import Carrusel from '../components/carrusel.js';


const Home = () => {
    
    useEffect(() => {
        new WOW.WOW({
          live: false
        }).init();
      }, [])
    const { setSorters, useNews, maxPage, setPage, files } = useContext(MyNewsContext);
    const { news, isError, isLoading } = useNews();

    const ref = useRef(null);
    useDocumentTitle("Inicio")

    return (
        <>
        <TittleNavBar/>
        <div className='flex flex-col md:gap-28 gap-20'>     
            <Carrusel news={news} files={files} />
            {/* <div className='relative bg-index-background bg-cover bg-center h-[300px] 2sm:h-fit 2sm:px-10 px-4'>
                <div className='flex flex-col items-center bg-black py-4 2sm:w-[400px] w-[80%] 2sm:p-6 p-2 rounded-xl mt-[180px] 2sm:mt-[21%] 2sm:mb-[13%] bg-opacity-70 shadow-xl animate__animated animate__fadeInUp'>
                    <h1 className='text-center font-mono font-bold w-full  text-white  lg:text-2xl md:text-xl text-sm '>DIRECCIÓN DE GESTIÓN CATASTRAL MULTIPROPÓSITO</h1>
                    <div className='bg-green-500 h-[3px] w-[90px] my-4'></div>
                </div>
               
            </div> */}

            <div className=' flex justify-center items-center lg:mx-6 '>
                <div className='items-center content-center flex flex-col lg:mx-8 lg:w-[60%]  py-4 px-4 wow animate__animated animate__slideInUp animate__slow'>
                    <h3 className='text-black lg:text-4xl text-xl 2sm:font-semibold font-bold text-center font-mono '>¡Bienvenidos a Catastro Neiva!</h3>
                    <div className='bg-green-500 h-[3px] w-[90px] my-4'></div>
                    <p className='text-gray-800 lg:text-2xl text-center font-mono '>La Dirección de Gestión Catastral Multipropósito es la entidad encargada de la gestión catastral de la ciudad de Neiva, en el departamento del Huila, Colombia.</p>
                    <Link to="/catastro" className='bg-green-400 hover:bg-green-500 text-white font-bold py-2 px-4 rounded mt-4 '>Leer más</Link>
                </div>
            </div>

            <div className='relative w-full bg-black lg:opacity-80'>
                <div className='bg-home-background bg-cover h-[550px] md:w-[420px] w-full '></div>
                <div className='absolute top-0 left-0 w-full h-full bg-black bg-opacity-80 2sm:bg-opacity-30 2sm:px-10 px-4'>
                    <div className='flex flex-col justify-center items-center h-full 2md:w-[50%] lg:w-[60%] xl:w-[70%] w-full  float-right'>
                        <p className='text-white font-base lg:text-xl font-mono mb-4 text-center wow animate__animated animate__slideInUp animate__slow'>Descubre cómo obtener certificados catastrales, realizar cambios en la titularidad de tu propiedad, conocer el valor de tu predio y mucho más.</p>
                        <div className='flex flex-row gap-6'> 
                            <div className='flex flex-col items-center wow animate__animated animate__slideInUp animate__slow'>
                                <Link to="tramites" className=' hover:bg-green-500 text-white font-bold py-2 px-4 rounded mt-4 border-4 w-[170px] h-[170px] border-green-400 shadow-sm shadow-white '>
                                    <ContourLines fill="currentColor" stroke="currentColor" className='w-full h-full' />
                                </Link>
                                <h4 className='text-white font-bold mt-2'> Trámites y Productos</h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className='2sm:px-12 px-4 flex 2sm:flex-row flex-col justify-between'>
                <div className='flex flex-col  justify-center 2sm:w-[40%] w-full mt-5 2sm:mb-0 mb-8 2sm:ml-10 items-center wow animate__animated 2sm:animate__backInLeft animate__fadeInUp animate__slow' >
                    <h4 className='text-black 2sm:text-2xl text-xl 2sm:font-semibold font-bold font-mono text-center'> Observatorio Inmobiliario</h4>
                    <div className='bg-green-500 h-[3px] w-[90px] my-4'></div>
                    <p className='text-black 2sm:text-lg font-mono text-center'> Aquí encontrarás datos estadísticos, análisis y tendencias relevantes sobre la compra, venta y alquiler de propiedades. ¡Ingresa ahora y descubre todo lo que podemos ofrecerte!</p>
                </div>
                <div className={`relative bg-home rounded-xl 2sm:w-[40%] w-full py-4 flex items-center justify-center hover:shadow-xl shadow wow animate__animated 2sm:animate__backInRight animate__fadeInUp animate__slow`} onMouseOver={() => {ref.current.classList.remove('hidden');}} onMouseOut={() => {ref.current.classList.add('hidden');}}>
                    <Observatory fill="currentColor" stroke="currentColor" className='w-[500px] h-full' />
                    <div className='absolute rounded-xl h-full w-full bg-cartMap  items-center justify-center flex hidden' ref={ref}>
                        <a href={OBSERVATORYLINK} target="_blank" rel="noopener noreferrer" className='bg-green-400 hover:bg-green-500 text-white font-bold py-2 px-4 rounded mt-4 '>Ver mapa</a>
                    </div>
                </div>
            </div>


            <div className='relative w-full bg-neiva-background bg-cover 2sm:h-[calc(80vh)] h-[700px] py-8 '>
                <div className='absolute top-0 left-0 w-full px-4 h-full bg-teal-900 flex flex-col lg:flex-row items-center justify-around bg-opacity-70'>
                    <div className='flex flex-col justify-around items-around 2sm:w-[90%] lg:w-[45%] 2md:w-[80%] w-full lg:h-[60%] text-white '>
                        <h1 className='font-bold 2sm:text-4xl text-2xl font-mono text-center'>Apertura del proceso de actualización Catastral del Municipio de Neiva</h1>
                        <br />
                        <p>
                            De acuerdo con el decreto 892 del 31 de octubre de 2023, se inició la socialización nivel uno al alcalde de Neiva y su equipo, con quienes se ha logrado una buena acogida. Para el 8 de noviembre se culminó la socialización de nivel uno al sector constructor, las curadurías, las notarías. También se pidió apoyo a la Defensoría, personería, procuraduría y otros órganos de control para el seguimiento al proceso de actualización catastral de Neiva.
                        </p>
                        <br />
                        <p>
                            En los próximos días se continuará con la socialización nivel dos, invitando a los líderes, lideresas, juntas comunales y administradores de propiedades horizontales para explicarles el proceso de actualización catastral, cómo se hará y qué beneficios tendrá la actualización catastral con enfoque multipropósito en Neiva.
                        </p>
                    </div>
                    <iframe className='w-full my-5 2sm:w-[90%] lg:w-[45%] 2md:w-[80%] wow animate__animated animate__zoomIn animate__slow' height="420" src="https://www.youtube.com/embed/Se19Y8ygevA" title="Catastro" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>
                </div>
            </div>



            {/*News*/}
            <div className='mb-20'>

            <Subtitle title="Destacados" />

            <div className='w-[50%] sm:w-[35%] lg:w-[15%] mx-auto mt-2'>
                <Sorters setSorters={setSorters} />
            </div>

            <Loading isLoading={isLoading} />

            <div className='flex flex-wrap justify-center items-center w-11/12 lg:px-4 lg:py-4 md:px-4 md:py-4 px-2 py-2 mx-auto'>

                {news ? news.length > 0 ? news.map((newN, index) => (
                    <News key={index} newN={newN} number={index} />
                )) : <h1 className='text-center w-full font-light mb-4'>No hay registros para mostrar</h1> : null
                }
            </div>
            {isError ? <h1 className='text-center text-red-400 w-full mb-4'>Ha ocurrido un error al cargar los datos.</h1> : null}
            {maxPage < 1 ? null : <div className='flex justify-center'>
                <Pager maxPage={maxPage} setPage={setPage} scrollT={false} />
            </div>}
            </div>

        </div>
        </>
    );
}

export default Home;